import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

import { AuthContext } from '@dashboard/context/AuthContext';

import Button from '@dashboard/components/Button';
import Spinner from '@dashboard/components/Spinner';

import { fetchPaymentMethod } from './helpers';
import FormSubmit from '@dashboard/components/Form/components/FormSubmit';
import { FormElement } from '@dashboard/components/Form';

const PaymentMethod = ({ setEditing }) => {
  const { seller, sellerId, token } = useContext(AuthContext);

  const planHandle = seller && seller.plan && seller.plan.handle;

  const [paymentMethod, setPaymentMethod] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (paymentMethod) return;

    async function getPaymentMethod() {
      try {
        const { data, error: err } = await fetchPaymentMethod(sellerId, token);

        if (err) throw new Error(err);

        setPaymentMethod(data);
        setLoading(false);
        setError('');
      } catch (err) {
        setError(err.message || 'Unable to fetch payment method');
        setLoading(false);
      }
    }

    getPaymentMethod();
  }, [paymentMethod, planHandle]);

  if (loading) {
    return <Spinner />;
  }

  if (paymentMethod) {
    return (
      <>
        {error && <FormElement>{error}</FormElement>}

        <div className="flex flex-row mb-2">
          <div className="font-semibold w-64">Card number:</div>
          <div>
            {`${paymentMethod.card.brand} (**** **** **** ${paymentMethod.card.last4})`}
          </div>
        </div>

        <div className="flex flex-row mb-2">
          <div className="font-semibold w-64">Expires:</div>
          <div>{`${paymentMethod.card.exp_month} / ${paymentMethod.card.exp_year}`}</div>
        </div>

        <FormSubmit>
          <Button appearance="secondary" handleClick={() => setEditing(true)}>
            Update card
          </Button>
        </FormSubmit>
      </>
    );
  }

  if (!paymentMethod) {
    return (
      <>
        <FormElement>{`You haven't added a payment method yet`}</FormElement>

        {error && <FormElement>{error}</FormElement>}

        <FormSubmit>
          <Button appearance="secondary" handleClick={() => setEditing(true)}>
            Add card
          </Button>
        </FormSubmit>
      </>
    );
  }
};

PaymentMethod.propTypes = {
  setEditing: PropTypes.func.isRequired,
};

export default PaymentMethod;
